import { api } from "../api";
import { EventResponse } from "../../../types/types";

/**
 * commandFindLastFiveResultResponse - Function that finds on database the last five command result response data    
 * /devices/{status}   
 * method GET 
 * @async-function
 */
const commandFindLastFiveResultResponse = async (token: string, deviceId: number, plate: string) => {
    if (deviceId == null || deviceId == -1) {
        return await api.get<Array<EventResponse>>(
            `/commands/lastByPlate/${plate}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        );
    } else {
        return await api.get<Array<EventResponse>>(
            `/commands/last/${deviceId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
        );
    }
};

export default commandFindLastFiveResultResponse;
